import React from "react";

import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import { ReactComponent as GraphIcon } from "../../../../assets/graph-default.svg";
import { ReactComponent as GraphIconSelected } from "../../../../assets/graph-selected.svg";
import { ReactComponent as GlossaryIcon } from "../../../../assets/glossary-icon.svg";
import { ReactComponent as GlossaryIconSelected } from "../../../../assets/glossary-selected.svg";
import { ReactComponent as ExitIcon } from "../../../../assets/exit-icon.svg";
import "../../../../App.scss";
import { Typography } from "@mui/material";
import { BoxsMenu, ListComponent, ListItemButtonComponent, ListItemGoOut } from "./styles";

interface SideMenuProps {
    onToggle: (value: { showMap: boolean; showGlossary: boolean }) => void;
    values: {
        showMap: boolean;
        showGlossary: boolean;
    };
}

const SideMenu = ({ onToggle, values: { showGlossary, showMap } }: SideMenuProps) => {
    const exitButton = () => {
        window.location.href = "https://ilia.digital";
    };

    return (
        <>
            <ListComponent disablePadding>
                <ListItem disablePadding>
                    <ListItemButtonComponent
                        isselected={String(showMap)}
                        id="map-btn"
                        onClick={() => {
                            onToggle({
                                showMap: true,
                                showGlossary: false,
                            });
                        }}
                    >
                        <ListItemIcon sx={{ minWidth: "auto", marginTop: "8px" }}>
                            <BoxsMenu>
                                {showMap ? <GraphIconSelected /> : <GraphIcon />}
                                <Typography
                                    fontFamily="IliaMontSerratSemiBold"
                                    fontWeight="700"
                                    fontSize="14px"
                                    lineHeight="17.07px"
                                    color="#2B25B8"
                                    id="map-side-menu-title"
                                    sx={{ marginTop: "5px" }}
                                >
                                    Mapa
                                </Typography>
                            </BoxsMenu>
                        </ListItemIcon>
                    </ListItemButtonComponent>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButtonComponent
                        isselected={String(showGlossary)}
                        id="glossary-btn"
                        onClick={() => {
                            onToggle({
                                showMap: false,
                                showGlossary: true,
                            });
                        }}
                    >
                        <ListItemIcon>
                            <BoxsMenu>
                                {showMap ? <GlossaryIcon /> : <GlossaryIconSelected />}
                                <Typography
                                    fontFamily="IliaMontSerratSemiBold"
                                    fontWeight="600"
                                    fontSize="14px"
                                    lineHeight="17.07px"
                                    color="#9192AD"
                                    id="glossary-side-menu-title"
                                    sx={{ marginTop: "5px" }}
                                >
                                    Glossário
                                </Typography>
                            </BoxsMenu>
                        </ListItemIcon>
                    </ListItemButtonComponent>
                </ListItem>
                <ListItemGoOut disablePadding>
                    <Divider style={{ width: "100%" }} />
                    <ListItemButtonComponent isselected={"false"} onClick={exitButton}>
                        <ListItemIcon sx={{ minWidth: "auto" }}>
                            <BoxsMenu>
                                <ExitIcon width="40px" height="40px" />
                                <Typography fontFamily="IliaMontSerratSemiBold" fontWeight="600" fontSize="14px" lineHeight="17.07px" color="#9192AD">
                                    Sair
                                </Typography>
                            </BoxsMenu>
                        </ListItemIcon>
                    </ListItemButtonComponent>
                </ListItemGoOut>
            </ListComponent>
        </>
    );
};

export default SideMenu;
